module.exports = __webpack_public_path__ + "img/card_english.37b315d4.png";